import React from "react";
import { QRCodeSVG } from "qrcode.react";

const Portrait = ({ widget }) => {
  const createWiFiQRText = () => {
    return `WIFI:T:${widget.data?.encryption};S:${widget.data?.ssid};P:${widget.data?.password};;`;
  };
  return (
    <div
      className="h-100 d-flex flex-column justify-content-center align-items-center"
      style={{
        background: "#51B3F6",
      }}
    >
      <img src="/images/wifi/wifi-signals.png" alt="" />
      <div
        className="card"
        style={{
          background: "#1475CC",
          height: "50%",
          width: "80%",
          borderRadius: "25px",
        }}
      >
        <div className="card-body">
          <div className="d-flex justify-content-between h-100 flex-column">
            <div
              className="w-100 p-2"
              style={{
                background: widget.data.bgColor || "#fff",
                borderRadius: "25px",
              }}
            >
              <QRCodeSVG
                bgColor="transparent"
                fgColor={widget.data.qrColor}
                level="Q"
                style={{
                  width: "100%",
                  height: "100%",
                  padding: "10px",
                }}
                value={createWiFiQRText()}
              />
            </div>
            <h3 className="text-center text-white">SCAN TO CONNECT</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portrait;
